/** Shared UPI VPA validation (aligned with backend paymentValidation). */
export const UPI_ID_REGEX = /^[A-Za-z0-9._-]{2,256}@[A-Za-z][A-Za-z.-]{1,63}$/;

export const getUpiIdError = (value) => {
  const upi = String(value || '').trim();
  if (!upi) return '';
  if (upi.length > 80) return 'UPI ID is too long';
  if (!UPI_ID_REGEX.test(upi)) return 'Enter a valid UPI ID (e.g. name@bank)';
  return '';
};
